import ContactSection from "./contact-us";
import Footer from "./footer";
import Navbar from "./navbar";

export default function Layout(props) { 


    const children = props.children;

    
    
    return (
       <>
        <Navbar />
        {children}

        <div className="section contact-us">
        <ContactSection />
        </div>
        <Footer />
       </>
    )
    
};